import axios from 'axios';

export const otApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/ot`,
    headers: {
        'Content-Type': 'application/json'
    }
})